/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Apikeymanager_Placeholder_None2Inputs */

const id_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada kunci API dibuat`)
};

const ms_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada kunci API dijana`)
};

const da_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen API nøgle genereret`)
};

const de_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein API-Schlüssel generiert`)
};

const en_us2_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key generated`)
};

const es_es2_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha generado ninguna clave de API`)
};

const es_mx2_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha generado API key`)
};

const fil_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang na-generate na API key`)
};

const fr_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune clé API générée`)
};

const it_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna chiave API generata`)
};

const hu_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs API kulcs létrehozva`)
};

const nl_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen API-sleutel gegenereerd`)
};

const no_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen API-nøkkel generert`)
};

const pl_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie wygenerowano klucza API`)
};

const pt_br2_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key generated`)
};

const pt_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma chave de API gerada`)
};

const ro_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicio cheie API generată`)
};

const fi_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-avainta ei ole luotu`)
};

const sv_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen API-nyckel genererad`)
};

const vi_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa tạo khóa API`)
};

const tr_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API anahtarı oluşturulmadı`)
};

const cs_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyl vygenerován žádný API klíč`)
};

const bg_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не е генериран API ключ`)
};

const ru_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ не сгенерирован`)
};

const uk_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ не згенеровано`)
};

const ar_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم إنشاء مفتاح API`)
};

const hi_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई API कुंजी नहीं`)
};

const th_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่ได้สร้างคีย์ API`)
};

const ja_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API キーが生成されていません`)
};

const zh_cn2_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key generated`)
};

const zh_hant1_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key generated`)
};

const ko_components_apikeymanager_placeholder_none2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_None2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key generated`)
};

/**
* | output |
* | --- |
* | "No API key generated" |
*
* @param {Components_Apikeymanager_Placeholder_None2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_apikeymanager_placeholder_none2 = /** @type {((inputs?: Components_Apikeymanager_Placeholder_None2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Apikeymanager_Placeholder_None2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "ms") return ms_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "da") return da_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "de") return de_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "en-US") return en_us2_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "es-ES") return es_es2_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "es-MX") return es_mx2_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "fil") return fil_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "fr") return fr_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "it") return it_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "hu") return hu_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "nl") return nl_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "no") return no_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "pl") return pl_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "pt-BR") return pt_br2_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "pt") return pt_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "ro") return ro_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "fi") return fi_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "sv") return sv_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "vi") return vi_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "tr") return tr_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "cs") return cs_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "bg") return bg_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "ru") return ru_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "uk") return uk_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "ar") return ar_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "hi") return hi_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "th") return th_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "ja") return ja_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_apikeymanager_placeholder_none2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_apikeymanager_placeholder_none2(inputs)
	return ko_components_apikeymanager_placeholder_none2(inputs)
});
export { components_apikeymanager_placeholder_none2 as "components.apiKeyManager.placeholder.none" }